import { render, staticRenderFns } from "./BrowseCourses.vue?vue&type=template&id=3ef932ce&"
import script from "./BrowseCourses.vue?vue&type=script&lang=js&"
export * from "./BrowseCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports